import { z } from '@harvestiq/zod';
import { coverageSchema } from './coverage';

export const getCoverageResponseSchema = z.object({
  coverage: coverageSchema,
});
export type GetCoverageResponse = z.infer<typeof getCoverageResponseSchema>;
